// lib/supabase.ts
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://kxgreiplxhpwtqicdgnx.supabase.co'
const supabaseAnonKey = 'sb_publishable_WGXnU3AMNEKCfWO11S-buw_g_k4-grK'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)